import React from 'react';

// Importazione manuale delle immagini per sicurezza e stabilità
import img1 from '../images/location/d8aef3_08b4bbab912d48b186a82742f05632fa~mv2.avif';
import img2 from '../images/location/d8aef3_2d8d3374ab744d32ace890d270df0669~mv2.avif';
import img3 from '../images/location/d8aef3_392a62fbc9a34964b728a4efa9de4d14~mv2.avif';
import img4 from '../images/location/d8aef3_4673e9b8be64483488eae63be97b4f80~mv2_d_6620_4680_s_4_2.avif';
import img5 from '../images/location/d8aef3_47baff081a3942e6a596e871578cd923~mv2.avif';
import img6 from '../images/location/d8aef3_62d499ff2a4c4513a71898be13833a4c~mv2.avif';
import img7 from '../images/location/d8aef3_631401e3f1144f4c9031bfedc1be9d93~mv2.avif';
import img8 from '../images/location/d8aef3_6541c4eee35d48a582c2c502e8545cda~mv2.avif';
import img9 from '../images/location/d8aef3_866221010b364efdbf84cb51d0a07139~mv2.avif';
import img10 from '../images/location/d8aef3_fd7a3e312fd04ea89b97db19c0d97cfd~mv2.avif';

const locationImages = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

const LocationPage = () => {
  return (
    <>
      <style>{`
        .location-page {
          min-height: 100vh;
          padding: 100px 20px 40px; /* Padding top per compensare header fisso */
          background: #fdfcfb;
          font-family: 'Josefin Sans', sans-serif;
        }

        .location-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .location-header {
          text-align: center;
          margin-bottom: 50px;
          animation: fadeIn 1s ease-out;
        }

        .location-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 42px;
          color: #3a4a5c;
          margin-bottom: 15px;
          font-style: italic;
        }

        .location-desc {
          color: #5a6a7c;
          font-size: 16px;
          line-height: 1.6;
          max-width: 600px;
          margin: 0 auto;
          font-weight: 300;
        }

        /* Masonry Grid Layout */
        .masonry-grid {
          column-count: 1;
          column-gap: 20px;
        }

        @media (min-width: 600px) {
          .masonry-grid {
            column-count: 2;
          }
        }

        @media (min-width: 900px) {
          .masonry-grid {
            column-count: 3;
          }
        }

        .masonry-item {
          break-inside: avoid;
          margin-bottom: 20px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0,0,0,0.05);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          opacity: 0;
          animation: fadeInUp 0.8s ease-out forwards;
        }

        .masonry-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(195, 229, 234, 0.4);
        }

        .masonry-img {
          width: 100%;
          height: auto;
          display: block;
          transition: transform 0.5s ease;
        }

        .masonry-item:hover .masonry-img {
          transform: scale(1.03);
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div className="location-page">
        <div className="location-container">
          <div className="location-header">
            <h1 className="location-title">Le 7 Fonti</h1>
            <p className="location-desc">
              Un luogo incantato dove la natura incontra l'eleganza. 
              Immerso nel verde, perfetto per celebrare il nostro giorno speciale.
            </p>
          </div>

          <div className="masonry-grid">
            {locationImages.map((src, index) => (
              <div 
                key={index} 
                className="masonry-item"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <img src={src} alt={`Location view ${index + 1}`} className="masonry-img" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationPage;
